import React from 'react';
import TextAdapter from './TextAdapter';
import { AdapterProps } from '../types';

const NumberAdapter = (props: AdapterProps['number']) => {
  return (
    <TextAdapter
      type="number"
      inputmode="numeric"
      onBeforeInput={(event: any) => {
        if (event.data && /\D\./.test(event.data)) {
          event.preventDefault();
        }
      }}
      {...props}
    />
  );
};

export default NumberAdapter;
